import React, { useRef, useState } from 'react';
import {
  FilterPod,
  TableComponents,
  ConfirmDialog,
  PageContainer,
  SimpleDialog,
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { useStyles } from './style';
import { Box, Button, Grid, } from '@mui/material';
import {
  businessGetPermissionGuild,
  confirmPermissionGuild,
  revokePermissionGuild,
  deletePermissionGuild
} from '../services/services';
import { columns, generateData, InitFilters, GrantedPermissionGuildDg } from './components';
import { useLocation } from 'react-router-dom';
import useCustomHook from './constants/hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

const GrantedGuild = () => {
  const {
    loading,
    setLoading,
    actionLoading,
    setActionLoading,
    isConfirmOpen,
    setIsConfirmOpen,
    isBusinessGrantPermissionOpen,
    setIsBusinessGrantPermissionOpen,
    setFilterParams,
    size,
    setSize,
    page, setPage,
    selectedRow, setSelectedRow,
    dialogData, setDialogData
  } = useCustomHook();

  const [filters, setFilters] = useState(InitFilters());
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'permissionsGrantedGuildBtn',
      'permissionsGrantedUpdateGuildBtn',
      'permissionsGrantedDeleteGuildBtn',
      'newPermissionsGrantedGuildBtn',
      'permissionsGrantedCancelGuildBtn',

    ])
  const tableRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const guildCode = searchParams.get('guildCode');
  const classes = useStyles();
  const getRequestsData = async (query) => {
    try {
      setLoading(true);
      const orderBy = [];
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      if (guildCode) {
        params = {
          ...params,
          guildCode: guildCode,
        };
      }

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await businessGetPermissionGuild(params, guildCode);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d;
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  /**
   * علمیات تایید
   */
  const confirmRequest = async (rowData) => {
    try {
      setActionLoading(true);
      await confirmPermissionGuild(rowData?.id, guildCode);
      setActionLoading(false);
      refreshTable()
    } catch (e) {
      setActionLoading(false);
    } finally {
    }
  };

  /**
   *  عملیات لغو
   */
  const revokeService = async (rowData) => {
    try {
      setActionLoading(true);
      await revokePermissionGuild(rowData?.id, guildCode);
      setActionLoading(false);
      refreshTable()
    } catch (e) {
      setActionLoading(false);
    } finally {
    }
  };

  /**
   *  عملیات حذف
   */
  const deleteService = async (rowData) => {
    try {

      setActionLoading(true);
      await deletePermissionGuild(rowData?.id, guildCode);
      setActionLoading(false);
      refreshTable();
    } catch (e) {
      setActionLoading(false);
    } finally {
    }
  };

  const handleCloseDialog = () => {
    setIsConfirmOpen(false);
  };
  const refreshTable = () => {
    setIsConfirmOpen(false);
    setTimeout(() => {
      tableRef?.current?.onChangeTable();
      setDialogData(null);
    }, 100)
  }

  /**
   * هرکدام از اکشن های داخل عملیات کلیک میشود
   */
  const onActionClick = (row, type) => {
    setSelectedRow(row);
    if (type === 'delete') {
      setDialogData({
        onConfirm: () => deleteService(row),
        title: 'حذف مجوز',
        content: 'آیا از حذف مجوز مورد نظر اطمینان دارید؟',
        confirmButtonText: "بله، حذف مجوز",
        cancelButtonProps: "انصراف",
      })
    } else if (type === 'cancel') {
      setDialogData({
        onConfirm: () => revokeService(row),
        title: 'لغو مجوز',
        content: 'آیا از لغو مجوز مورد نظر اطمینان دارید؟',
        confirmButtonText: "بله، لغو مجوز",
        cancelButtonProps: "انصراف",
      })
    } else {
      setDialogData({
        onConfirm: () => confirmRequest(row),
        title: 'تایید مجوز',
        content: 'آیا از تایید مجوز مورد نظر اطمینان دارید؟',
        confirmButtonText: "بله، تایید مجوز",
        cancelButtonProps: "انصراف",
      })
    }
    setTimeout(() => {
      setIsConfirmOpen(true);
    }, 100);
  }

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const onGrantPermission = () => {
    setIsBusinessGrantPermissionOpen(true);
  };

  const onCloseGuildPermission = () => {
    setIsBusinessGrantPermissionOpen(false);
    setTimeout(() => {
      tableRef?.current?.onChangeTable();
    }, 100)
  };


  const hint =
    'در پلتفرم کسب وکار، از طریق ایجاد مجوز برای کسب وکار دیگر، این امکان وجود دارد که آن کسب وکار دسترسی انجام عملیات مالی از جمله: کلیه عملیات مربوط به فاکتور، انتقال وجه، درخواست تسویه حساب، درخواست موجودی و درخواست صورتحساب مورد نظر را بر روی کسب وکار شما داشته باشد. همچنین این امکان وجود دارد که مجوزهای صادر شده، به طور کامل حذف یا به صورت موقت لغو شود و در صورت تمایل با تایید مجدد، فعال گردد.';

  return (
    <PageContainer
      meta={
        actionsList['newPermissionsGrantedGuildBtn'] && (
          <Button
            className={classes.cardHeaderButton}
            onClick={onGrantPermission}
            color="primary"
            variant="contained"
          >
            اعطای مجوز مالی
          </Button>
        )
      }
      title="مجوزهای مالی اعطا شده"
      pageKey="grantPermissionRequests"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.PERMISSION_GRANTED_GUILD}
    >

      {
        actionsList['permissionsGrantedGuildBtn'] && (
          <>
            <Grid item xs={12}>
              <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
                <FilterButton
                  setOpenFilterDialog={setOpenFilterDialog}
                  filters={filters}
                />
              </Box>
              <Box>
                <FilterPod
                  filters={filters}
                  onChange={onFiltersChange}
                  openFilterDialog={openFilterDialog}
                  setOpenFilterDialog={setOpenFilterDialog}
                  handleCloseFilterDialog={handleCloseFilterDialog}
                />
              </Box>
            </Grid>
            <TableComponents
              data={getRequestsData}
              columns={columns(actionsList, actionLoading, onActionClick)}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber)
                setSize(ps?.pageSize)
                return getRequestsData(ps)
              }}
            />
          </>
        )
      }

      < ConfirmDialog
        open={isConfirmOpen}
        onClose={handleCloseDialog}
        loading={actionLoading}
        onConfirm={() => dialogData?.onConfirm()}
        title={dialogData?.title}
        content={dialogData?.content}
        confirmButtonText={dialogData?.confirmButtonText}
        cancelButtonProps={dialogData?.cancelButtonProps}
      />

      <SimpleDialog
        title={` اعطای مجوز "${guildCode}"`}
        open={isBusinessGrantPermissionOpen}
        style={{ maxWidth: 500 }}
        onClose={() => {
          setIsBusinessGrantPermissionOpen(false);
        }}
      >
        <GrantedPermissionGuildDg
          onClose={() => onCloseGuildPermission()}
          guildCode={guildCode}
          cancelClick={() => {
            setIsBusinessGrantPermissionOpen(false);
          }}
        />
      </SimpleDialog>
    </PageContainer >
  );
};


export default GrantedGuild;
